export default "/images/slack.png?123e3c19f796110e029ee9476fe33bba";